import React from 'react';
import {Row, Col, FormControl, ControlLabel, FormGroup} from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import Cleave from 'cleave.js/react';

const SupplierFormMoreInfos = ({ updateFormValue, website, siret, numeroTVA, codeAPE, group }) =>{
  return(
    <div>
      <h4><FormattedMessage id='ids_moreInfos'
        description="collaborator more infos input field label"
        defaultMessage="Autres infos" /></h4>
      <FormGroup>
        <ControlLabel>
        <FormattedMessage id='ids_website'/>
      </ControlLabel>
        <FormControl
        placeholder="www.softthinks.com"
        name="website"
        value={website}
        onChange= {(e) => updateFormValue("website", e.target)}
        />
      </FormGroup>
        <FormGroup>
      <ControlLabel>
        <FormattedMessage id='ids_siret'
          description="collaborator siret input field label"
          defaultMessage="SIRET"
          />
      </ControlLabel>
      <Cleave
        className="form-control"
        placeholder="000000000 00000"
        name="siret"
        style={{ textTransform: "uppercase" }}
        options={{ blocks: [9,5], delimiter: ' ', numericOnly: true }}
        value={siret}
        onChange= {(e) => updateFormValue("siret", e.target)} />
        </FormGroup>
      <Row>
        <Col sm={6}>
            <FormGroup>
          <ControlLabel>
            <FormattedMessage id='ids_numeroTVA'/>
          </ControlLabel>
          <Cleave
            className="form-control"
            placeholder="0000000000"
            name="numeroTVA"
            style={{ textTransform: "uppercase" }}
            options={{ blocks: [10], numericOnly: true }}
            value={numeroTVA}
            onChange= {(e) => updateFormValue("numeroTVA", e.target)} />
            </FormGroup>
        </Col>
        <Col sm={6}>
            <FormGroup>
          <ControlLabel>
            <FormattedMessage id='ids_APE'/>
          </ControlLabel>
          <Cleave
            className="form-control"
            placeholder="0000 A"
            name="codeAPE"
            style={{ textTransform: "uppercase" }}
            options={{ blocks: [4,1], delimiter: ' ' }}
            value={codeAPE}
            onChange= {(e) => updateFormValue("codeAPE", e.target)} />
            </FormGroup>
        </Col>
      </Row>
        <FormGroup>
            <ControlLabel>
                <FormattedMessage id='ids_group'/>
            </ControlLabel>
            <FormControl
                placeholder="Entrer un groupe"
                name="group"
                value={group}
                onChange= {(e) => updateFormValue("group", e.target)} />
        </FormGroup>
    </div>
  )
}

export default SupplierFormMoreInfos;
